import React, { lazy } from "react";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";

// const sanityConfig = { projectId: "s2j9sc95", dataset: "production" };
import sanityConfig from "../../config/sanity";

const SanityImage = ({
  input,
  objectFit = "contain",
  // caption,
  showPlaceholder = true,
  defaultWidth = 2000,
}) => {
  // const [imageLoaded, setImageloaded] = useState(false)
  // return null;

  const { asset, altText } = input;
  const { metadata } = asset;
  // console.log("altText", altText);

  const width = defaultWidth;
  const height = width / metadata.dimensions.aspectRatio;
  // const imagePlaceholder = getImage(asset);
  const imageData = getGatsbyImageData(
    asset,
    {
      width: width,
      height: height,
      // maxWidth: width,
      // maxHeight: height,
      fit: "FILLMAX",
      // formats: ["AUTO", "WEBP", "AVIF"],
      // placeholder: "BLURRED",
    },
    sanityConfig.sanity
  );
  // console.log(imageData);

  return (
    <figure className='relative'>
      {showPlaceholder && (
        <div
          className='absolute bg-placeholder w-full h-full'
          style={{
            backgroundColor: metadata.palette.dominant.background,
          }}></div>
      )}
      <GatsbyImage
        image={imageData}
        alt={altText ? altText : ""}
        objectFit={objectFit}
        style={{ position: "unset" }}
      />
    </figure>
  );
};

export default SanityImage;
